module.exports = __webpack_public_path__ + "static/4-605037a2e116d8c1299a901aed8984ba.png";